<template>
    <div class="box collapsed-box">
        <div class="box-header with-border">
            <h3 class="box-title">Histórico do paciente <a data-toggle="tooltip" data-placement="top" title="Paciente possui agendamentos ainda não realizados." v-if="showInfo" href="" @click.prevent="$emit('showModalNaoRealizados')"><span class="fa fa-info-circle"></span></a></h3>
            <div class="box-tools pull-right">
                <button type="button" class="btn btn-box-tool" data-widget="collapse">
                    <i class="fa fa-plus"></i>
                </button>
            </div>
        </div>
        <div class="box-body">
            <div class="row">
                <div class="col-md-4">
                    <div class="form-group">
                        <div class="form-group">
                            <label for="">Unidade Solicitante</label>
                            <select-unidade
                                @setUnidadeSelecionada="
                                    unidadeSelecionada => {
                                        setUnidadeSolicitante(unidadeSelecionada);
                                    }
                                "
                            ></select-unidade>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label for="">Unidade realizadora</label>
                        <select-unidade
                            @setUnidadeSelecionada="
                                unidadeSelecionada => {
                                    setUnidadePrestadora(unidadeSelecionada);
                                }
                            "
                        ></select-unidade>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label for="">Procedimento</label>
                        <select-procedimento
                            @setProcedimentoSelecionado="
                                procedimentoSelecionado => {
                                    setProcedimentoSelecionado(procedimentoSelecionado);
                                }
                            "
                        ></select-procedimento>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <label for>Profissional solicitante</label>
                    <select-profissional
                        tipo-profissional="Solicitante"
                        @setProfissionalSolicitanteSelecionado="
                            profissional => {
                                setProfissionalSolicitanteSelecionado(profissional);
                            }
                        "
                    ></select-profissional>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label for="">Profissional realizador</label>
                        <select-profissional
                            tipo-profissional="Realizador"
                            @setProfissionalRealizadorSelecionado="
                                profissional => {
                                    setProfissionalRealizadorSelecionado(profissional);
                                }
                            "
                        ></select-profissional>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label for="">Profissional marcador</label>
                        <select-usuario
                            nivel="marcador"
                            @setUsuarioSelecionado="
                                usuario => {
                                    setUsuarioSelecionado(usuario);
                                }
                            "
                        ></select-usuario>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-2">
                    <div class="form-group">
                        <label for>Situação da solicitação</label>
                        <select v-model="filtros.situacao" class="form-control">
                            <option value>Todas</option>
                            <option :value="SITUACAO_SOLICITACAO.MARCADA">Marcada</option>
                            <option :value="SITUACAO_SOLICITACAO.EM_REGULACAO">Em regulação</option>
                            <option :value="SITUACAO_SOLICITACAO.REGULADA">Regulada</option>
                            <option :value="SITUACAO_SOLICITACAO.INFORMACAO_PENDENTE">Informação pendente</option>
                            <option :value="SITUACAO_SOLICITACAO.INFORMACAO_ADICIONAL">Informação adicional</option>
                            <option :value="SITUACAO_SOLICITACAO.NEGATIVADA">Negativada</option>
                            <option :value="SITUACAO_SOLICITACAO.CONFIRMADA">Confirmada</option>
                            <option :value="SITUACAO_SOLICITACAO.CANCELADA">Cancelada</option>
                            <option :value="SITUACAO_SOLICITACAO.FALTA">Falta</option>
                            <option :value="SITUACAO_SOLICITACAO.REALIZADA">Realizada</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label for="">Data da solicitação </label>
                        <input v-model="filtros.data_solicitacao" class="form-control" type="date" name="" id="" />
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label for="">Data de realização</label>
                        <input v-model="filtros.data_realizacao" class="form-control" type="date" name="" id="" />
                    </div>
                </div>
                <div class="col-md-2">
                    <div class="form-group">
                        <label for="">&nbsp;</label>
                        <button type="button" @click="getHistorico()" class="btn btn-block btn-default"><span class="fa fa-filter"></span> Filtrar</button>
                    </div>
                </div>
            </div>
            <label for>Histórico do sistema novo</label>
            <table class="table table-bordered table-striped">
                <thead>
                    <tr>
                        <th>Situação</th>
                        <th>Unidade realizadora</th>
                        <th>Data da realização</th>
                        <th>Prof. Realizador</th>
                        <th>Procedimento</th>
                        <th>Solicitado em</th>
                        <th>Unidade solicitante</th>
                        <th>Prof. Solicitante</th>
                        <th>Prof. Marcador</th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="even" role="row" v-for="(item, index) in historico.data" :key="index">
                        <td>
                            <strong :class="item.solicitacao.situacao | situacaoSolicitacaoColor">
                                {{ item.solicitacao.situacao | situacaoSolicitacao }}
                            </strong>
                        </td>
                        <td>{{ item.contrato_procedimento_atendimento ? item.contrato_procedimento_atendimento.contrato_procedimento.contrato.unidade.nome : item.contrato_subgrupo_atendimento.contrato_subgrupo.contrato.unidade.nome }}</td>
                        <td>{{ item.contrato_procedimento_atendimento ? item.contrato_procedimento_atendimento.data_atendimento : item.contrato_subgrupo_atendimento.data_atendimento | dataFormatada }}</td>
                        <td>{{ item.contrato_procedimento_atendimento ? item.contrato_procedimento_atendimento.profissional.nome : "SEM PROFISSIONAL" }}</td>
                        <td>{{ item.contrato_procedimento.procedimento.nome }}</td>
                        <td>{{ item.solicitacao.created_at | dataFormatada }}</td>
                        <td>{{ item.contrato_procedimento.contrato.unidade.nome }}</td>
                        <td>{{ item.solicitacao.profissional.nome }}</td>
                        <td>{{ item.solicitacao.usuario.name }}</td>
                    </tr>
                </tbody>
            </table>
            <br />
            <div class="row">
                <div class="col-sm-5">Mostrando {{ this.historico.from }} até {{ this.historico.to }} de {{ this.historico.total }} registros encontrados.</div>
                <div class="col-sm-7" style="text-align:right">
                    <laravue-pagination :limit="7" :data="historico" v-on:pagination-change-page="getHistorico">
                        <span slot="prev-nav">&lt; Anterior</span>
                        <span slot="next-nav">Próximo &gt;</span>
                    </laravue-pagination>
                </div>
            </div>
            <br />
            <form action="">
                <div class="row">
                    <div class="col-md-4">
                        <div class="form-group">
                            <div class="form-group">
                                <label for="">Unidade Solicitante</label>
                                <input v-model="filtrosAntigo.unidade_solicitante" class="form-control" type="text" />
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="">Unidade realizadora</label>
                            <input v-model="filtrosAntigo.unidade_realizadora" class="form-control" type="text" />
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="">Procedimento</label>
                            <input v-model="filtrosAntigo.procedimento" class="form-control" type="text" />
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <label for>Profissional solicitante</label>
                        <input v-model="filtrosAntigo.profissional_solicitante" class="form-control" type="text" />
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="">Profissional realizador</label>
                            <input v-model="filtrosAntigo.profissional_realizador" class="form-control" type="text" />
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="">Profissional marcador</label>
                            <input v-model="filtrosAntigo.profissional_marcador" class="form-control" type="text" />
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-2">
                        <div class="form-group">
                            <label for>Situação da solicitação</label>
                            <select v-model="filtrosAntigo.situacao" class="form-control">
                                <option value>Todas</option>
                                <option :value="SITUACAO_SOLICITACAO_ANTIGA.EM_ANALISE">Em análise</option>
                                <option :value="SITUACAO_SOLICITACAO_ANTIGA.APROVADA">Aprovada</option>
                                <option :value="SITUACAO_SOLICITACAO_ANTIGA.CONFIRMADA">Confirmada</option>
                                <option :value="SITUACAO_SOLICITACAO_ANTIGA.NEGADA">Negada</option>
                                <option :value="SITUACAO_SOLICITACAO_ANTIGA.EM_PERICIA">Em perícia</option>
                                <option :value="SITUACAO_SOLICITACAO_ANTIGA.CANCELADA">Cancelada</option>
                                <option :value="SITUACAO_SOLICITACAO_ANTIGA.REALIZADA">Confirmada</option>
                                <option :value="SITUACAO_SOLICITACAO_ANTIGA.FALTA">Falta</option>
                                <option :value="SITUACAO_SOLICITACAO_ANTIGA.EM_SUPERVISAO">Em supervisão</option>
                                <option :value="SITUACAO_SOLICITACAO_ANTIGA.SUPERVISIONADO">Supervisionado</option>
                                <option :value="SITUACAO_SOLICITACAO_ANTIGA.EM_EXTRAPOLACAO">Em extrapolação</option>
                                <option :value="SITUACAO_SOLICITACAO_ANTIGA.TFD">TFD</option>
                                <option :value="SITUACAO_SOLICITACAO_ANTIGA.FALTA_AUTOMATICA">Falta automática</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="">Data da solicitação </label>
                            <input v-model="filtrosAntigo.data_solicitacao" class="form-control" type="date" />
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="">Data de realização</label>
                            <input v-model="filtrosAntigo.data_realizacao" class="form-control" type="date" />
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="form-group">
                            <label for="">&nbsp;</label>
                            <button type="button" @click="getHistoricoAntigo()" class="btn btn-block btn-default"><span class="fa fa-filter"></span> Filtrar</button>
                        </div>
                    </div>
                </div>
            </form>
            <label for>Histórico importado da base de dados anterior</label>
            <router-link style="margin: 0px 0px 5px 10px" v-if="this.hasPermission('paciente.read')" tag="a" class="btn btn-sm btn-warning" to="/integracao/pacientes"> <i class="fa fa-user"></i> Ir para o CADASTRO DE PACIENTES no módulo de integração com o sistema antigo </router-link>
            <table class="table table-bordered table-striped">
                <thead>
                    <tr>
                        <th>Situação</th>
                        <th>Unidade realizadora</th>
                        <th>Data da realização</th>
                        <th>Prof. Realizador</th>
                        <th>Procedimento</th>
                        <th>Solicitado em</th>
                        <th>Unidade solicitante</th>
                        <th>Prof. Solicitante</th>
                        <th>Prof. Marcador</th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="even" role="row" v-for="(item, index) in historicoAntigo.data" :key="index">
                        <td>
                            <strong :class="item.situacao | situacaoSolicitacaoAntigaColor">
                                {{ item.situacao | situacaoSolicitacaoAntiga }}
                            </strong>
                        </td>
                        <td>{{ item.unidade_realizadora }}</td>
                        <td>{{ item.data_realizacao | dataFormatada }}</td>
                        <td>{{ item.profissional_realizador }}</td>
                        <td>{{ item.procedimento }}</td>
                        <td>{{ item.data_solicitacao | dataFormatada }}</td>
                        <td>{{ item.unidade_solicitante }}</td>
                        <td>{{ item.profissional_solicitante }}</td>
                        <td>{{ item.profissional_marcador }}</td>
                    </tr>
                </tbody>
            </table>
            <br />
            <div class="row">
                <div class="col-sm-5">Mostrando {{ this.historicoAntigo.from }} até {{ this.historicoAntigo.to }} de {{ this.historicoAntigo.total }} registros encontrados.</div>
                <div class="col-sm-7" style="text-align:right">
                    <laravue-pagination :limit="7" :data="historicoAntigo" v-on:pagination-change-page="getHistoricoAntigo">
                        <span slot="prev-nav">&lt; Anterior</span>
                        <span slot="next-nav">Próximo &gt;</span>
                    </laravue-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios"; // Cliente para requisição http
import selectUnidade from "@/components/cadastros/unidades/selectUnidade";
import selectUsuario from "@/components/cadastros/usuarios/selectUsuario";
import selectProcedimento from "@/components/cadastros/procedimentos/selectProcedimento";
import selectProfissional from "../../cadastros/profissionais/selectProfissional";
import { SITUACAO_SOLICITACAO, SITUACAO_SOLICITACAO_ANTIGA } from "@/constants";
export default {
    props: ["pacienteId", "showInfo"],
    computed: {
        SITUACAO_SOLICITACAO: function() {
            return SITUACAO_SOLICITACAO;
        },
        SITUACAO_SOLICITACAO_ANTIGA: function() {
            return SITUACAO_SOLICITACAO_ANTIGA;
        }
    },
    components: { selectProfissional, selectUnidade, selectProcedimento, selectUsuario },
    data: () => ({
        historicoAntigo: {},
        historico: {},
        filtros: {
            unidade_solicitante_id: "",
            unidade_realizadora_id: "",
            procedimento_id: "",
            profissional_realizador_id: "",
            profissional_solicitante_id: "",
            profissional_marcador_id: "",
            situacao: "",
            data_solicitacao: "",
            data_realizacao: ""
        },
        filtrosAntigo: {
            unidade_solicitante: "",
            unidade_realizadora: "",
            procedimento: "",
            profissional_realizador: "",
            profissional_solicitante: "",
            profissional_marcador: "",
            situacao: "",
            data_solicitacao: "",
            data_realizacao: ""
        }
    }),
    mounted() {},
    methods: {
        setUnidadeSolicitante(unidadeSolicitante) {
            this.filtros.unidade_solicitante_id = unidadeSolicitante.id;
        },
        setUnidadePrestadora(unidadePrestadora) {
            this.filtros.unidade_realizadora_id = unidadePrestadora.id;
        },
        setProcedimentoSelecionado(procedimentoSelecionado) {
            this.filtros.procedimento_id = procedimentoSelecionado.id;
        },
        setProfissionalSolicitanteSelecionado(profissional) {
            this.filtros.profissional_solicitante_id = profissional.id;
        },
        setUsuarioSelecionado(usuario) {
            this.filtros.profissional_marcador_id = usuario.id;
        },
        setProfissionalRealizadorSelecionado(profissional) {
            this.filtros.profissional_realizador_id = profissional.id;
        },
        getHistorico(page) {
            if (typeof page === "undefined") {
                page = 1;
            }

            let config = this.$store.getters.getHeaderAuth;
            this.filtros.page = page;
            config.params = this.filtros;

            axios
                .get(`${this.$store.state.serverURI}/api/cadastros/pacientes/getHistorico/` + this.$props.pacienteId, config)
                .then(response => {
                    this.historico = response.data;
                })
                .catch(error => {
                    console.log(error);
                });
        },
        getHistoricoAntigo(page) {
            if (typeof page === "undefined") {
                page = 1;
            }

            let config = this.$store.getters.getHeaderAuth;
            this.filtrosAntigo.page = page;
            config.params = this.filtrosAntigo;

            axios
                .get(`${this.$store.state.serverURI}/api/cadastros/pacientes/getHistoricoAntigo/` + this.$props.pacienteId, config)
                .then(response => {
                    this.historicoAntigo = response.data;
                })
                .catch(error => {
                    console.log(error);
                });
        }
    },
    watch: {
        "$props.pacienteId": function(val) {
            if (val) {
                this.getHistorico();
                this.getHistoricoAntigo();
            }
        }
    }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// historicos.vue?51b73666